
export const PROBATE_SCROLL_EVENT = "probate:scroll_to";

export type ProbateScrollTarget = {
    target: "properties";
    focus?: "main_residence" | "deceased_share" | "passes_to"
};

export function emitProbateScroll(target: ProbateScrollTarget) {
    console.debug("[probate] emit probate:scroll_to", target);
    window.dispatchEvent(new CustomEvent(PROBATE_SCROLL_EVENT, { detail: target }));
}
